import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { DoctorService } from "../../services";

function UpsertClinicModal(props) {
  const handleClose = () => {
    props.setShowUpsertModal(false);
  };

  async function onFormSubmit(e) {
    e.preventDefault();
    const Id = props.clinic.Id;

    const formData = new FormData(e.target);
    const formDataObj = Object.fromEntries(formData.entries());

    let Action = "I";
    if (Id != 0) Action = "U";

    const result = DoctorService.upsertClinic(Action, Id, formDataObj)
      .then((respond) => {
        handleClose();
      })
      .catch((err) => {
        console.log("error in upsert clinic");
      });
  }

  return (
    <>
      <Modal centered show={props.show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Clinic Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={onFormSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Clinic Name:</Form.Label>
              <Form.Control
                type="text"
                name="ClinicName"
                defaultValue={props.clinic.ClinicName}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address:</Form.Label>
              <Form.Control
                type="text"
                name="Adres"
                defaultValue={props.clinic.Adres}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone:</Form.Label>
              <Form.Control
                type="text"
                name="Phone1"
                defaultValue={props.clinic.Phone1}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email:</Form.Label>
              <Form.Control
                type="text"
                name="email"
                defaultValue={props.clinic.email}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Invoice Title:</Form.Label>
              <Form.Control
                type="text"
                name="InvoiceTitle"
                defaultValue={props.clinic.InvoiceTitle}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Invoice Address:</Form.Label>
              <Form.Control
                type="text"
                name="InvoiceAddress"
                defaultValue={props.clinic.InvoiceAddress}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>VD:</Form.Label>
              <Form.Control
                type="text"
                name="VD"
                defaultValue={props.clinic.VD}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>TC/VN:</Form.Label>
              <Form.Control
                type="text"
                name="TCVN"
                defaultValue={props.clinic.TCVN}
              />
            </Form.Group>
            <Button type="submit">Submit</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UpsertClinicModal;
